import axios, { AxiosInstance } from 'axios'
import LocalStorageUtils from '../utils/LocalStorageUtils'

export function createApiClient(baseURL: string): AxiosInstance {
  const client = axios.create({ baseURL })

  client.interceptors.request.use((requestConfig) => {
    const token = LocalStorageUtils.getToken()
    if (token) {
      requestConfig.headers = requestConfig.headers || {}
      requestConfig.headers.Authorization = `Bearer ${token}`
    }
    return requestConfig
  })

  client.interceptors.response.use(
    (response) => response,
    async (error) => {
      const status = error?.response?.status

      if (status === 401) {
        try {
          const [{ store }, { logout }] = await Promise.all([
            import('../store'),
            import('../features/auth/authSlice'),
          ])
          store.dispatch(logout())
        } catch (logoutError) {
          console.error('Failed to auto-logout on 401 response', logoutError)
        }
      }

      return Promise.reject(error)
    },
  )

  return client
}
